import { apiFetch } from '../admin/jscontrol/apiClient';
import { ensureLoggedInUserId } from './cartApi';

const profileFetchOptions = { useStorefrontAuth: true };

export function mapUserToProfileForm(user = {}) {
  return {
    firstName: String(user.FirstName ?? user.firstName ?? '').trim(),
    lastName: String(user.LastName ?? user.lastName ?? '').trim(),
    email: String(user.Email ?? user.email ?? '').trim(),
    username: String(user.Username ?? user.username ?? '').trim(),
    password: '',
    confirmPassword: '',
    mobile: String(user.MobileNumber ?? user.mobileNumber ?? user.Mobile ?? '').trim(),
  };
}

export function mapUserToProfileMeta(user = {}) {
  const userId = Number(user.UserId ?? user.userId ?? 0);
  const roleId = user.RoleId ?? user.roleId;

  return {
    userId: Number.isFinite(userId) && userId > 0 ? userId : null,
    roleId: roleId != null && roleId !== '' ? Number(roleId) : null,
    gender: user.Gender ?? user.gender ?? null,
    dateOfBirth: user.DateOfBirth ?? user.dateOfBirth ?? null,
    isEmailVerified: !!(user.IsEmailVerified ?? user.isEmailVerified),
    isMobileVerified: !!(user.IsMobileVerified ?? user.isMobileVerified),
    isBlocked: !!(user.IsBlocked ?? user.isBlocked),
  };
}

export async function fetchCurrentUserProfile() {
  const userId = await ensureLoggedInUserId();
  if (!userId) throw new Error('Please login to edit your profile.');

  const { data } = await apiFetch(`/User/GetById/${userId}`, profileFetchOptions);
  const user = data?.data ?? data;
  if (!user || !(user.UserId ?? user.userId)) {
    throw new Error('Could not load your profile.');
  }

  return {
    form: mapUserToProfileForm(user),
    meta: mapUserToProfileMeta(user),
  };
}

export async function updateCustomerProfile(form, meta) {
  if (!meta?.userId) throw new Error('Invalid user.');

  const payload = {
    UserId: meta.userId,
    FirstName: String(form.firstName || '').trim(),
    LastName: String(form.lastName || '').trim() || null,
    Email: String(form.email || '').trim(),
    Username: String(form.username || '').trim(),
    MobileNumber: String(form.mobile || '').trim() || null,
    Gender: meta.gender || null,
    DateOfBirth: meta.dateOfBirth || null,
    IsEmailVerified: meta.isEmailVerified,
    IsMobileVerified: meta.isMobileVerified,
    IsBlocked: meta.isBlocked,
    RoleId: meta.roleId,
  };

  const password = String(form.password || '').trim();
  if (password) {
    payload.Password = password;
  }

  await apiFetch('/User/Update', {
    method: 'PUT',
    data: payload,
    ...profileFetchOptions,
  });
}
